import { initValidate } from "../utils/error";
/**
 * 将页面加载完成处理成promise
 * @param image image对象
 * @param src 直接输入url地址
 * @param test 测试所需 强制失败
 */
export function imageLoad({ image, src, test = false }) {
  if (!image && !src) return;
  let img = image;
  if (src) {
    img = new Image();
    img.src = src;
  }
  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      if (test) {
        reject(
          initValidate({
            msg: "network error11",
          })
        );
      } else {
        resolve(img);
      }
    };
    img.onerror = () => {
      console.error("图片加载失败");
      reject(
        initValidate({
          msg: "network error",
        })
      );
    };
  });
  return promise;
}



// WEBPACK FOOTER //
// ./src/utils/media.js